import customLangParser from './custom-lang-mapping';
import defaultStakeBrands from './default-stake-brands';

/**
 * @description Mapping Factory
 *
 * @param {string} type type
 * @param {string} operator operator
 * @param {string} brand brand
 */
const mappingFactory = (type, operator, brand) => {
    switch (type) {
    case 'customLang':
        return customLangParser(operator, brand);
    case 'defaultStakeBrands':
        return defaultStakeBrands;
    }
};

export default mappingFactory;
